import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { JobDocsContainerModel, JobHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginDriverJobHdrService extends BaseApiTemplateService<JobHeaderContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep';
    this.httpClient = http;
  }

  getJobs(requestDto: Object, visa: ApiVisa) {
    let url = this.apiUrl + '/job-hdr-listings/query';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/job-hdr-listings/query';
    }
    return this.httpClient.post(url, requestDto, this.getHttpHeader(visa));
  }

  getJobsByGuid(requestDto: Object, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/multi-jobs/login-driver-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/multi-jobs/login-driver-ep';
    }
    return <Observable<JobDocsContainerModel>>this.httpClient.post(url, requestDto, this.getHttpHeader(visa));
  }

  getJobsByCriteria(requestDto: Object, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/multi-jobs/login-driver-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/multi-jobs/login-driver-ep';
    }
    return this.httpClient.post(url, requestDto, this.getHttpHeader(visa));
  }

  startJob(hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/start-jobs/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/start-jobs/' + hdrGuid;
    }
    return this.httpClient.post(url, null, this.getHttpHeader(visa));
  }

  completeJob(hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/complete-jobs/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/complete-jobs/' + hdrGuid;
    }
    return this.httpClient.post(url, null, this.getHttpHeader(visa));
  }

  cancelJob(hdrGuid: string, visa: ApiVisa) {
    let dto = {
      jobs_guids: [hdrGuid]
    }
    let url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/cancel-job/login-driver-ep'; // I'm doing this cuz the backend is weird
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docs/cancel-job/login-driver-ep';
    }
    return this.httpClient.post(url, dto, this.getHttpHeader(visa));
  }

  updateProofOfReceipt(jobHdrGuid: string, requestDto: Object, visa: ApiVisa) {
    let url = this.apiUrl + '/updateProofOfReceipt/' + jobHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/updateProofOfReceipt/' + jobHdrGuid;
    }
    return this.httpClient.put(url, requestDto, this.getHttpHeader(visa));
  }

  updateSequenceInTrip(requestDto: Object, visa: ApiVisa) {
    let url = this.apiUrl + '/update-job-sequence-in-trips';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/update-job-sequence-in-trips/'
    }
    return this.httpClient.post(url, requestDto, this.getHttpHeader(visa));
  }

}